import React, { useState, useEffect } from "react";
import { Row, Col, Tab, Tabs, Form } from "react-bootstrap";
import { LegendField, LegendTextarea, IconField } from "../../components/fields";
import { Item, Anchor, Box, Button, Image } from "../../components/elements";
import { CardLayout, TabCard, RolesCard, UserRoleCard, UserPermissionsCard } from "../../components/cards";
import { Breadcrumb, FileUpload } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import data from "../../data/master/myAccount.json";
import Spinner from 'react-bootstrap/Spinner'
import { Alert } from "react-bootstrap";
import api from "../../data/master/api.json";
export default function MyAccount() {
    
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(localStorage.getItem("title"));

    const [oldPassword, setOldPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const handleSubmit1 = (e) => {
        e.preventDefault();
        doProfileUpdate();
    }; 

    const handleSubmit2 = (e) => {
        e.preventDefault();
        doPasswordUpdate();
    }; 

    const doProfileUpdate = async () => {
        setLoading(true)
        setAlertMessage('');
        await fetch(api.base_url+api.update_user_profile, {
            method: 'POST',
            body: JSON.stringify({
                title: title            
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Authorization': 'bearer ' + localStorage.getItem('session_id'),
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then((response) => response.json())
            .then((data) => {
                    setAlertMessage( data['message'] );
                    if ( data['status'] === 'success' ){
                        localStorage.setItem("title", title)
                    }
            })
            .catch((err) => {
                console.log(err.message);
            });
        setLoading(false)
    };

    const doPasswordUpdate = async () => {
        setLoading(true)
        setAlertMessage('');
        await fetch(api.base_url+api.update_user_password, {
            method: 'POST',
            body: JSON.stringify({
                old_password: oldPassword,
                password_1: password1,
                password_2: password2
            }),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Authorization': 'bearer ' + localStorage.getItem('session_id'),
                "Access-Control-Allow-Origin": "*"
            },
        })
            .then((response) => response.json())
            .then((data) => {
                    setAlertMessage( data['message'] );
                    setOldPassword('');
                    setPassword1('');
                    setPassword2('');
            })
            .catch((err) => {
                console.log(err.message);
            });
        setLoading(false)
    };

    let valert;
    if (alertMessage !== '' ) {
        valert = <Alert key="abc123" variant="warning" onClose={() => setAlertMessage('')} dismissible>{alertMessage}</Alert>
    } else {
        valert = ""
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <Breadcrumb title={ data?.pageTitle }>
                        {data?.breadcrumb.map((item, index) => (
                            <Item key={ index } className="mc-breadcrumb-item">
                                {item.path ? <Anchor className="mc-breadcrumb-link" href={ item.path }>{ item.text }</Anchor> : item.text }
                            </Item>
                        ))}
                    </Breadcrumb>
                </Col>
                <Col xl={12}>
                    <CardLayout>
                        <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
                            <Tab eventKey="profile" title="Define Roles" className="mc-tabpane profile">
                                <TabCard title="Roles">
                                    <Row>
                                        <Col xl={12}>
                                            <RolesCard />
                                        </Col>
                                    </Row>
                                </TabCard>
                            </Tab>
                            <Tab eventKey="password" title="Assign User Roles" className="mc-tabpane password">
                                <TabCard title="Assign User Roles">
                                    <UserRoleCard/>
                                </TabCard>
                            </Tab>
                            <Tab eventKey="permissions" title="View User Permissions" className="mc-tabpane permissions">
                                <TabCard title="User Permissions">
                                    <UserPermissionsCard />
                                </TabCard>
                            </Tab>
                        </Tabs>
                    </CardLayout>
                </Col>
            </Row>
        </PageLayout>
    )
}